module.exports = __webpack_public_path__ + "img/wholesalers.b865e0e4.svg";